<template>
  <h2 class="topic-title">2024 Key Topics</h2>
</template>

<script>
export default {
  name: 'TopicTitle'
};
</script>

<style scoped>
.topic-title {
  font-family: Red Hat Display;
  font-weight: 600;
  font-size: 62px;
  line-height: 110%;
  letter-spacing: 0%;
  text-align: center;
  color: #111111;
  margin-bottom: 50px;
}
</style>
